// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-3mZYO";
var _5 = "title-dgSkx";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "title" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "title": _5 }
